import styles from "./RedLight.module.scss"

interface RedLightProps {
  size?: number
  color?: string
}

const RedLight = ({ size = 8, color }: RedLightProps) => {
  return (
    <div
      className={styles.light}
      style={{
        width: size,
        height: size,
        ...(color
          ? {
              backgroundColor: color,
              boxShadow: `0 0 6px 1px ${color}80, 0 0 12px 2px ${color}33`,
            }
          : {}),
      }}
    />
  )
}

export default RedLight
